import './search.css';

var styles = {"wrapper":"wrapper__2fJi3","searchFor":"searchFor__3-1IR","searchLabel":"searchLabel__1Z1ld","suggestionSection":"suggestionSection__T-Czh","suggestion":"suggestion__YXGqk","content":"content__1tQyy","pageOverlay":"pageOverlay__kdxd3","categoriesPageWrapper":"categoriesPageWrapper__2FIDi"};

export { styles as default };
